import React, { useState } from "react";
import Header from "../../components/Header";
import {
  FaBuilding,
  FaMapMarkerAlt,
  FaBriefcase,
  FaBusinessTime,
} from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import sampleJobsData from "../../data/sampleJobs.json";
import { formatDate } from "../../utilities/formatDate";
import JobDetailsModal from "./JobDetailsModal";
import { IoSearch } from "react-icons/io5";

const JobApplicationPage = () => {
  // const sampleJobsData = { jobList: [] };

  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const openModal = (job) => {
    setSelectedJob(job);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedJob(null);
  };
  //TODO: Add functionality to fetch jobs from the database
  // Filter jobs based on search term
  const filteredJobs = sampleJobsData.jobList.filter((job) =>
    job.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Header />
      <div className="bg-gray-100 pb-10 sticky top-[7.5rem] z-40 h-[calc(100vh-7.5rem)] overflow-y-auto">
        <main className="shadow-md bg-white max-w-screen-xl p-4 lg:pb-14 md:px-20 w-full mx-auto min-h-[100%]">
          <div className="flex flex-row justify-between">
            <h1 className="text-lg lg:text-2xl font-bold text-gray-600 text-left mb-6">
              Open Job Opportunities{" "}
              <span className="text-lg font-bold">({filteredJobs.length})</span>
            </h1>

            <div className="relative font-semibold text-gray-500  sm:w-1/3 mt-4 mb-4 sm:mt-0">
              <input
                type="text"
                className="border-2 border-green-700 rounded-xl p-2 pl-14 w-full"
                placeholder="Search available jobs...."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <IoSearch className="absolute left-5 top-3 text-green-700 text-xl" />
            </div>
          </div>

          <div className="space-y-8 text-sm lg:text-base">
            {filteredJobs.length > 0 ? (
              filteredJobs.map((job, index) => (
                <div
                  key={index}
                  onClick={() => openModal(job)}
                  className="relative bg-gray-100 shadow-md transition-transform duration-300 hover:shadow-xl hover:scale-100 cursor-pointer py-3 px-6 lg:py-6 lg:pl-8 rounded-md w-full md:w-[90%] mx-auto"
                >
                  <h1 className="text-lg lg:text-xl font-semibold text-green-700 mb-2">
                    {job.title}
                  </h1>

                  <div className="flex flex-wrap items-center gap-4 font-medium text-black text-opacity-50 mb-4 text-sm lg:text-base">
                    <div className="flex items-center">
                      <FaBuilding className="mr-2 " />
                      <span>{job.institution}</span>
                    </div>
                    <div className="flex items-center">
                      <FaMapMarkerAlt className="mr-2 " />
                      <span>{job.location}</span>
                    </div>
                    <div className="flex items-center">
                      <FaBriefcase className="mr-2 " />
                      <span>{job.level}</span>
                    </div>
                    <div className="flex items-center">
                      <FaBusinessTime size={20} className="mr-2 " />
                      <span>{job.duration || "5 Years"}</span>
                    </div>
                  </div>

                  <div className="text-gray-600 mb-5">
                    <span className="font-medium">Application Deadline:</span>{" "}
                    <span className="font-semibold text-red-500">
                      {formatDate(job.deadline)}
                    </span>
                  </div>

                  <p className="text-sm lg:text-base font-medium text-gray-500 mb-11 line-clamp-2">
                    {job.details}
                  </p>

                  <div className="text-right absolute bottom-5 right-6">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        openModal(job);
                      }}
                      className="bg-green-700 font-semibold text-xs lg:text-sm text-white pl-8 pr-6 py-[9px] rounded-lg flex items-center justify-center gap-2 hover:bg-green-600"
                    >
                      View details
                      <IoIosArrowForward />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-red-600 font-semibold text-lg py-10">
                No vacancies available at the moment !!
              </div>
            )}
          </div>
        </main>
      </div>

      {/* Modal for Job Details */}
      {selectedJob && (
        <JobDetailsModal
          job={selectedJob}
          isOpen={isModalOpen}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default JobApplicationPage;
